import { useCallback, useContext, useMemo } from 'react';
import useSWR, { SWRConfiguration, mutate } from 'swr';
import { FormDefinitionSingleResponse, FormDefinitionGetSingleByCode } from '../../api/dtos';
import { BoundMutator } from '../../utilities/BoundMutator';
import FormsContext from '../../contexts/FormsContext';
import { Forms } from '../../Forms';

// @ts-ignore: declared but not used 'url'
const fetcher = async (url: string, forms: Forms, code: string) => {
    const response = await forms.serviceStackClient.get(new FormDefinitionGetSingleByCode({ code }));

    return response;
}

const useFormDefinitionByCode = (code?: string, configuration?: SWRConfiguration<FormDefinitionSingleResponse, FormDefinitionSingleResponse>) => {
    const forms = useContext(FormsContext);

    const { data, error } = useSWR<FormDefinitionSingleResponse, FormDefinitionSingleResponse>(code ? [`${forms.baseRoute}/forms-definition/single/code`, forms, code] : null, fetcher, configuration);

    const boundMutate: BoundMutator<FormDefinitionSingleResponse> = useCallback((data, shouldRevalidate) => {
        return mutate([`${forms.baseRoute}/forms-definition/single/code`, forms, code], data, shouldRevalidate);
    }, [forms, code])

    const result = useMemo(() => {
        return {
            data: data?.configuration,
            error: error?.responseStatus,
            loading: data === undefined && error === undefined,
            mutate: boundMutate
        };
    }, [boundMutate, data, error])

    return result;
}

export default useFormDefinitionByCode;